<script setup>
import TopPage from "@/components/templates/TopPageTemplate.vue"

import SideRight from "@/components/organisms/SideRightOrganism.vue"
import VueElementLoading from "vue-element-loading"

import { onMounted, ref, nextTick } from "vue"

import { sessionCheck, accessBannedCheck, adBlockCheck, useBraveCheck } from "@/js/startSettings"
import AdBlockWarning from "@/components/molecules/AdBlockWarningMolecule.vue"
import AccessBannedWarning from "@/components/molecules/AccessBannedWarningMolecule.vue"

const isAccessBanned = ref(false)
const bannedTo       = ref("")
const isBrave        = useBraveCheck()
const isAdBlocked    = ref(false)

const isLoading = ref(true)

sessionCheck()
adBlockCheck().then((flg) => {
  isAdBlocked.value    = flg
})

accessBannedCheck().then((data) => {
  isAccessBanned.value = data.is_banned
  bannedTo.value       = data.banned_to
})

onMounted(() => {
  // 子コンポーネントの読込が全て完了したら
  nextTick(() => {
    setTimeout(() => {
      isLoading.value = false
    }, 200)
  })
})
</script>

<template>
  <div class="css__app-area">
    <vue-element-loading :active="isLoading" spinner="ring" color="#383c3c" background-color="rgb(243, 243, 242)" text="Now Loading..." is-full-screen />
    <template v-if="isAccessBanned">
      <AccessBannedWarning :datetimeTo="bannedTo" />
    </template>
    <template v-else-if="!isAdBlocked && !isBrave">
      <TopPage />
      <SideRight />
    </template>
    <template v-else>
      <AdBlockWarning />
    </template>
  </div>
</template>